$(() => {
  const windowWidth = $(window).width();
	$.debounce = function (func, wait, immediate) {
		let timeout;
		return function () {
			const context = this,
				args = arguments;
			const later = function () {
				timeout = null;
				if (!immediate) func.apply(context, args);
			};
			const callNow = immediate && !timeout;
			clearTimeout(timeout);
			timeout = setTimeout(later, wait);
			if (callNow) func.apply(context, args);
		};
	};
  const wrapSearchElements = () => {
    if($('.search-input-wrapper').length < 1) {
      $('.mega-search').find($('input[type="submit"], input[type="text"]')).wrapAll("<div class='search-input-wrapper'></div>");
    }
	};
  $(window).on(
		'resize',
		$.debounce(function () {
			if ($(window).width() > 992) {
				wrapSearchElements();
			} 
		}, 300)
	);
  $(function () {
		if (windowWidth > 992) {
			wrapSearchElements();
		}
	});
});